import { UI, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React, { useEffect } from 'react';

import { UserSelectionsProps } from '../..';
import { InputMoney } from '../../../../../../../../../../../../components/InputMoney';
import { usePublicOfferAssetQuantityController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PublicOffer';

export interface PublicOfferQuantityFieldsProps extends Required<UserSelectionsProps> {}

export const PublicOfferQuantityFields: React.FC<PublicOfferQuantityFieldsProps> = ({
  offer,
  offerDetails,
  selectedModality,
  setUserSelectionValues,
}) => {
  const id = offer.offerId;

  const {
    control,
    amountItem,
    currentValue,
    currentValueFormatted,
    minimumValue,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
  } = usePublicOfferAssetQuantityController(offer, offerDetails, selectedModality);

  useEffect(() => {
    setUserSelectionValues((prev) => ({
      ...prev,
      amountItem,
      currentValue,
      hasError: !!hasError,
    }));
  }, [amountItem, currentValue, id, hasError, setUserSelectionValues]);

  return (
    <VStack space="stack.xxxs">
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Quantidade Desejada
        </UI.Text>

        <UI.InputStepper
          testID={`public-offer-amount-order-input${id}`}
          name={`public-offer-amount-order-input${id}`}
          stepperValue={1}
          min={selectedModality.minimumQuantity}
          max={selectedModality.maximumQuantity}
          keyboardType="numeric"
          fontSize={Typography['fontsize.md']}
          defaultValue={amountItem}
          onChange={handleChangeAmountItem}
          showErrorMessage={false}
        />
      </VStack>
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Valor desejado (R$)
        </UI.Text>

        <InputMoney
          id={`public-offer-input${id}`}
          name="priceItem"
          control={control}
          handleFocus={handleInputFocus}
          handleBlur={handleInputBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputClear}
          currentValue={currentValueFormatted}
          hasFocus={isFocused}
          minValue={minimumValue}
          customInputProps={{
            ...{
              ...(showMessageAdjustUnitPrice && {
                helpTextProps,
                helpText,
              }),
            },
            ...{ ...(isFocused && hasError && { error: hasError }) },
            ...{ ...(isFocused && !hasError && { helpText }) },
          }}
        />
      </VStack>
    </VStack>
  );
};
